import React, { useState, useEffect } from "react";
import "../ListStyles.css";

import { useNavigate } from "react-router-dom";

import useAxios from "../useAxios";

import moment from "moment";

const CompetitionsList = () => {
  const navigate = useNavigate();
  const [axios] = useAxios(true);

  const [competitions, setCompetitions] = useState([]);

  // Helper function to get status display name
  const getStatusName = (status) => {
    switch (status) {
      case 0:
        return "Pending";
      case 1:
        return "Started";
      case 2:
        return "Finished";
      default:
        return "Unknown";
    }
  };

  useEffect(() => {
    axios.get("competitions", setCompetitions);
  }, []);

  return (
    <div className="list-container">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 12,
          marginBottom: 24,
        }}
      >
        <h2 style={{ margin: 0 }}>Competitions</h2>
        <button
          className="edit-button"
          aria-label="Add New Competition"
          style={{
            fontSize: 24,
            padding: "4px 14px",
            margin: 0,
            lineHeight: 1,
          }}
          onClick={() => navigate("/competition/new")}
        >
          +
        </button>
      </div>

      {/* Desktop table view */}
      <table className="list-table desktop-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Date/Time</th>
            <th>Type</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {competitions
            .sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime))
            .map((competition) => (
              <tr key={competition.id}>
                <td>{competition.name}</td>
                <td>
                  {moment(competition.dateTime).format("DD/MM/yyyy HH:mm")}
                </td>
                <td>{competition.type?.name}</td>
                <td>{getStatusName(competition.status)}</td>
                <td>
                  <button
                    className="edit-button"
                    onClick={() => navigate("/competition/" + competition.id)}
                  >
                    Edit
                  </button>
                  <button
                    className="edit-button"
                    onClick={() =>
                      navigate("/competition/" + competition.id + "/draw")
                    }
                  >
                    Draw
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      {/* Mobile card view */}
      <div className="mobile-cards">
        {competitions
          .sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime))
          .map((competition) => (
            <div key={competition.id} className="mobile-card">
              <div className="mobile-card-header">
                <h3>{competition.name}</h3>
                <span className={`status-badge status-${competition.status}`}>
                  {getStatusName(competition.status)}
                </span>
              </div>
              <div className="mobile-card-body">
                <div className="mobile-card-row">
                  <span className="label">Date/Time:</span>
                  <span>{moment(competition.dateTime).format("DD/MM/yyyy HH:mm")}</span>
                </div>
                <div className="mobile-card-row">
                  <span className="label">Type:</span>
                  <span>{competition.type?.name}</span>
                </div>
              </div>
              <div className="mobile-card-actions">
                <button
                  className="edit-button"
                  onClick={() => navigate("/competition/" + competition.id)}
                >
                  Edit
                </button>
                <button
                  className="edit-button"
                  onClick={() =>
                    navigate("/competition/" + competition.id + "/draw")
                  }
                >
                  Draw
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default CompetitionsList;
